export default __webpack_public_path__ + "static/media/stanza4.ee6be03b.JPG";